import { FC, createContext, useCallback, useContext, useState } from 'react'
import {
  QueryRequestContextProps,
  QueryState,
  WithChildren,
  initialQueryRequest,
  initialQueryState,
} from '_metronic/helpers'

/** Números usados de um bloco, do mais recente para o mais antigo. */
const initialState: QueryState = {
  ...initialQueryState,
  sort: 'numeroSncr',
  order: 'desc',
}

const QueryRequestContext = createContext<QueryRequestContextProps>({
  ...initialQueryRequest,
  state: initialState,
})

export const QueryRequestProvider: FC<WithChildren> = ({ children }) => {
  const [state, setState] = useState<QueryState>(initialState)

  const updateState = useCallback(
    (updates: Partial<QueryState>) => setState((prev) => ({ ...prev, ...updates })),
    []
  )

  return (
    <QueryRequestContext.Provider value={{ state, updateState }}>
      {children}
    </QueryRequestContext.Provider>
  )
}

export const useQueryRequest = () => useContext(QueryRequestContext)
